import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";

const SILVER_IMG = "https://images.unsplash.com/photo-1605727216801-e27ce1d0cc28?auto=format&fit=crop&w=1400&q=80";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ loading: false, ok: false, error: "" });

  const onSubmit = async (e) => {
    e.preventDefault();
    setState({ loading: true, ok: false, error: "" });
    try {
      await api.post("/auth/forgot-password", { email });
      setState({ loading: false, ok: true, error: "" });
    } catch (err) {
      setState({ loading: false, ok: false, error: formatApiError(err.response?.data?.detail) || err.message });
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-[#0a0a0b]" data-testid="forgot-password-page">
      <div className="hidden md:block relative overflow-hidden border-r border-white/5 bg-black">
        <img src={SILVER_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0b]/40 via-transparent via-65% to-[#0a0a0b]" />
        <div className="absolute top-10 left-10"><Logo /></div>
        <div className="absolute bottom-12 left-10 right-10">
          <h2 className="font-display text-5xl text-white leading-[0.95] mb-3 tracking-tight">
            Lost the <em className="silver-text not-italic">key</em>?
          </h2>
          <p className="font-body text-sm text-zinc-400 max-w-md">
            We'll wire a reset link straight to your inbox. The link expires in 60 minutes — for
            obvious reasons.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12 relative">
        <div className="md:hidden absolute top-6 left-6"><Logo /></div>
        <div className="w-full max-w-md mt-12 md:mt-0">
          <div className="font-mono-apex text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">key recovery</div>
          <h1 className="font-display text-5xl md:text-6xl text-white mb-2 tracking-tight">Reset.</h1>
          <p className="font-body text-sm text-zinc-400 mb-10">
            Remembered it?{" "}
            <Link to="/login" className="text-white underline underline-offset-4 hover:text-[#dc2626]">
              Sign in
            </Link>
          </p>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="forgot-password-form">
            <div>
              <label className="font-mono-apex text-[10px] uppercase tracking-[0.25em] text-zinc-500 block mb-2">
                Email
              </label>
              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-apex w-full px-4 py-3 font-body text-sm"
                data-testid="forgot-email-input"
                autoComplete="email"
              />
            </div>

            {state.error && (
              <div className="font-mono-apex text-xs text-[#dc2626]" data-testid="forgot-error">{state.error}</div>
            )}
            {state.ok && (
              <div className="font-mono-apex text-xs text-emerald-400" data-testid="forgot-success">
                If an account exists, we just sent a reset link. Check your inbox.
              </div>
            )}

            <button
              type="submit"
              disabled={state.loading}
              className="w-full btn-primary-apex px-6 py-4 font-mono-apex text-[11px] uppercase tracking-[0.25em] disabled:opacity-60"
              data-testid="forgot-submit-btn"
            >
              {state.loading ? "Transmitting…" : "Send reset link"}
            </button>
          </form>

          <div className="mt-10 font-mono-apex text-[10px] uppercase tracking-[0.25em] text-zinc-700">
            ← <Link to="/" className="hover:text-zinc-400">return to surface</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
